const nodes = [
    {
        label: '招标公告',
        value: 21,
        date: '', // 若有则显示
        fields: [
            {
                label: '公告状态',
                value: '',
            },
            {
                label: '公告开始时间',
                value: '',
            },
        ],
        actions: [
            {
                label: '查看招标公告',
                value: 'zhaoBiaoGongGao',
            },
            // {
            //     label: '查看踏勘通知',
            //     value: 'taKanTongZhi',
            // },
        ],
    },
    {
        label: '招标文件',
        value: 22,
        actions: [
            {
                label: '查看招标文件',
                value: 'zhaoBiaoWenJian',
            },
            {
                label: '查看潜在投标人',
                value: 'qianZaiTouBiaoRen',
            },
            {
                label: '查看澄清问题',
                value: 'chenQingWenTi',
            },
            // {
            //     label: '查看异议',
            //     value: 'yiyi',
            // },
        ],
    },
    {
        label: '标前准备',
        value: 23,
        actions: [
            {
                label: '查看投标文件递交情况',
                value: 'touBiaoWenJianDiJiao',
            },
            {
                label: '查看场地预约情况',
                value: 'changDiYuYue',
            },
        ],
    },
    {
        label: '开标',
        value: 24,
        fields: [
            {
                label: '开标时间',
                value: '',
            },
            {
                label: '开标状态',
                value: '',
            },
            {
                label: '递交投标文件数量',
                value: '',
            },
            {
                label: '参与开标家数',
                value: '',
            },
        ],
        actions: [
            {
                label: '查看异议情况',
                value: 'yiYiQingKuang',
            },
            {
                label: '查看开标情况',
                value: 'url:/bidOpeningDetail',
            },
        ],
    },
    {
        label: '评标',
        value: 25,
        actions: [
            // {
            //     label: '查看复议',
            //     value: 'fuYi',
            // },
        ],
    },
    {
        label: '定标',
        value: 26,
        actions: [
            {
                label: '查看候选人公示',
                value: 'houXuanRenGongShi',
            },
            {
                label: '查看中标人',
                value: 'zhongBiaoRen',
            },
            {
                label: '查看中标结果公示',
                value: 'zhongBiaoJieGouGongShi',
            },
            {
                label: '查看中标通知书',
                value: 'zhongBiaoTongZhiShu',
            },
        ],
    },
    {
        label: '标后',
        value: 27,
        actions: [
            {
                label: '查看资料归档',
                value: 'ziLiaoGuiDang',
            },
        ],
    },
]
const getProjectStatusText = function (key) {
    const exist = nodes.find((t) => t.value === key)
    return exist ? exist.label : ''
}

module.exports = {
    nodes,
    getProjectStatusText,
}
